import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NavController, ModalController } from "@ionic/angular";
import { RechargeService } from "@wlp/ui-bs-recharge-phone";
import { LayoutConfigService } from "src/app/core/layout/services/layout-config.service";
import { LoadingService } from "src/app/core/layout/services/loading.service";
import { ModalAlertComponent } from "src/app/views/themes/sentinel/modals/modal-alert/modal-alert.component";

@Component({
  selector: 'app-recharge-value',
  templateUrl: './recharge-value.component.html',
  styleUrls: ['./recharge-value.component.scss']
})
export class RechargeValueComponent implements OnInit {

  backgroundHeaderLogon: any;
  cardIndex: number = -1;
  data: any;
  userProfile: any;
  history: any;
  productsData: any;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private navController: NavController,
    private router: Router,
    private rechargeService: RechargeService,
   /*  private storageService: StorageService,
    private authService: AuthService, */
    private modalController: ModalController,
    private load: LoadingService
  ) { }

  ngOnInit() {
    this.loadUser();
    this.backgroundHeaderLogon = this.layoutConfigService.getConfig('wlTheme.header.background.image');

    if (this.router.getCurrentNavigation().extras.state == undefined) {
      this.navController.navigateRoot(['/app/recharge-phone/phone-number']);
    } else {
      this.data = this.router.getCurrentNavigation().extras.state.data;
    }
  }

  selectedCard(index) {
    this.cardIndex = index;
  }

  continue() {
    this.router.navigate(['/app/recharge-phone/recharge-resume'], { state: { data: this.data } });
  }

  back() {
    this.navController.navigateRoot(['/app/recharge-phone/phone-number']);
  }

  private loadUser() {
   /*  this.authService.loadUserInfo().then((res) => {
      this.userProfile = res;
      this.getRechargeValues();
    }); */
  }


  getRechargeValues() {
   /*  this.storageService.get('historic').then(res => {
      this.history = res;
      if (this.history) {
        this.load.show()
        let numberFormatted = this.rechargeService.formatNumber(this.data.phoneNumber);
        this.rechargeService.consultProductsByOperator(
          this.userProfile.uuidAccount,
          numberFormatted.number,
          numberFormatted.ddd,
          this.data.operator,
          this.history
        ).subscribe(res => {
          if (res.statusCode == 400) {
            this.load.hide()
            this.notification('warning-circle', res.message, false);
          } else {
            this.load.hide()
            this.productsData = res.data;
          }
        })
      }
    }); */
  }

  private async notification(status: string, message: string, confirmation?: boolean) {
    const modalSuccess = await this.modalController.create({
      component: ModalAlertComponent,
      cssClass: 'modal-alert-class',
      componentProps: {
        status,
        message,
        confirmBtn: 'OK',
        confirmation,
        translate: true,
      },
      backdropDismiss: false,
    });

    return await modalSuccess.present();
  }

  cardSelected(cardSelected) {
    this.data = { ...this.productsData };
    delete this.data.list;
    this.data.value = cardSelected;
    console.log(this.data)
  }
}
